import { render, staticRenderFns } from "./LayoutNotifications.vue?vue&type=template&id=76acdb95&scoped=true"
import script from "./LayoutNotifications.vue?vue&type=script&lang=js"
export * from "./LayoutNotifications.vue?vue&type=script&lang=js"
import style0 from "./LayoutNotifications.vue?vue&type=style&index=0&id=76acdb95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76acdb95",
  null
  
)

export default component.exports